import React from 'react';
import get from 'lodash/get';
import Spacer from 'common/components/Spacer';
import { useEditor } from '@splashthat/splash-cms-engine';
import { SidebarPanel, SPACING } from 'common/components/TouchpointEditor/components/TouchpointSidebar';
import { containerPaddingL } from 'common/styles/variables';
import {
    NodeButton,
    NodeContainer,
} from 'common/components/TouchpointEditor/components/TouchpointSidebar/ElementsListMenu';
import ShowHideButton from 'common/components/TouchpointEditor/components/TouchpointSidebar/ShowHideButton';

import {
    // NODE IDS
    NODE_ID_PAGE_CONTAINER,
    NODE_ID_CONTENT_CONTAINER,
    NODE_ID_LOGO,
    NODE_ID_COUNTDOWN_TEXT,
    NODE_ID_CHECK_IN_BUTTON,
    NODE_ID_EVENT_TITLE,
    NODE_ID_FOOTER_CONTAINER,
    NODE_ID_CONTACT_ORGANIZER_BUTTON,
    NODE_ID_VISIT_EVENT_PAGE_BUTTON,
    NODE_ID_HEADER,
    NODE_ID_CUSTOM_BUTTON,
    NODE_ID_CUSTOM_BUTTON_TWO,

    // NODE DISPLAY NAMES
    NODE_DISPLAY_NAME_PAGE_CONTAINER,
    NODE_DISPLAY_NAME_CONTENT_CONTAINER,
    NODE_DISPLAY_NAME_LOGO,
    NODE_DISPLAY_NAME_EVENT_TITLE,
    NODE_DISPLAY_NAME_COUNTDOWN_TEXT,
    NODE_DISPLAY_NAME_CHECK_IN_BUTTON,
    NODE_DISPLAY_NAME_FOOTER_CONTAINER,
    NODE_DISPLAY_NAME_CONTACT_ORGANIZER_BUTTON,
    NODE_DISPLAY_NAME_VISIT_EVENT_PAGE_BUTTON,
    NODE_DISPLAY_NAME_CUSTOM_BUTTON,
    NODE_DISPLAY_NAME_CUSTOM_BUTTON_TWO,
    NODE_DISPLAY_NAME_HEADER,
} from '../../constants';

export default function ElementsListMenu() {
    const editor = useEditor((state) => ({
        nodes: {
            [NODE_ID_CUSTOM_BUTTON]: state.nodes[NODE_ID_CUSTOM_BUTTON],
            [NODE_ID_CUSTOM_BUTTON_TWO]: state.nodes[NODE_ID_CUSTOM_BUTTON_TWO],
        },
    }));

    const selectNode = (e, id) => {
        e.stopPropagation();
        editor.actions.selectNode(id);
    };

    const toggleNodeVisibility = (e, id) => {
        e.stopPropagation();
        editor.actions.setNodeProps(id, (node) => {
            // eslint-disable-next-line no-param-reassign
            node.meta.visible = !node.meta.visible;

            return node;
        });
    };

    return (
        <SidebarPanel variation="padded">
            <NodeButton
                variation="secondary"
                label={NODE_DISPLAY_NAME_PAGE_CONTAINER}
                qaId={NODE_ID_PAGE_CONTAINER}
                onClick={(e) => selectNode(e, NODE_ID_PAGE_CONTAINER)}
                onMouseEnter={() => editor.actions.hoverNode(NODE_ID_PAGE_CONTAINER)}
                onMouseLeave={() => editor.actions.unhoverAllNodes()}
                bold
            />
            <Spacer $spacing={containerPaddingL} />
            <NodeButton
                variation="secondary"
                label={NODE_DISPLAY_NAME_HEADER}
                qaId={NODE_ID_HEADER}
                onClick={(e) => selectNode(e, NODE_ID_HEADER)}
                onMouseEnter={() => editor.actions.hoverNode(NODE_ID_HEADER)}
                onMouseLeave={() => editor.actions.unhoverAllNodes()}
                bold
            />
            <Spacer $spacing={containerPaddingL} />
            <NodeContainer>
                <NodeButton
                    paddingLeft="0"
                    variation="navigation"
                    label={NODE_DISPLAY_NAME_CONTENT_CONTAINER}
                    qaId={NODE_ID_CONTENT_CONTAINER}
                    onClick={(e) => selectNode(e, NODE_ID_CONTENT_CONTAINER)}
                    onMouseEnter={() => editor.actions.hoverNode(NODE_ID_CONTENT_CONTAINER)}
                    onMouseLeave={() => editor.actions.unhoverAllNodes()}
                    bold
                />
                <NodeButton
                    label={NODE_DISPLAY_NAME_LOGO}
                    variation="secondary"
                    qaId={NODE_ID_LOGO}
                    onClick={(e) => selectNode(e, NODE_ID_LOGO)}
                    onMouseEnter={() => editor.actions.hoverNode(NODE_ID_LOGO)}
                    onMouseLeave={() => editor.actions.unhoverAllNodes()}
                />
                <Spacer $spacing={SPACING} />
                <NodeButton
                    label={NODE_DISPLAY_NAME_EVENT_TITLE}
                    variation="secondary"
                    qaId={NODE_ID_EVENT_TITLE}
                    onClick={(e) => selectNode(e, NODE_ID_EVENT_TITLE)}
                    onMouseEnter={() => editor.actions.hoverNode(NODE_ID_EVENT_TITLE)}
                    onMouseLeave={() => editor.actions.unhoverAllNodes()}
                />
                <Spacer $spacing={SPACING} />
                <NodeButton
                    label={NODE_DISPLAY_NAME_COUNTDOWN_TEXT}
                    variation="secondary"
                    qaId={NODE_ID_COUNTDOWN_TEXT}
                    onClick={(e) => selectNode(e, NODE_ID_COUNTDOWN_TEXT)}
                    onMouseEnter={() => editor.actions.hoverNode(NODE_ID_COUNTDOWN_TEXT)}
                    onMouseLeave={() => editor.actions.unhoverAllNodes()}
                />
                <Spacer $spacing={SPACING} />
                <NodeButton
                    label={NODE_DISPLAY_NAME_CHECK_IN_BUTTON}
                    variation="secondary"
                    qaId={NODE_ID_CHECK_IN_BUTTON}
                    onClick={(e) => selectNode(e, NODE_ID_CHECK_IN_BUTTON)}
                    onMouseEnter={() => editor.actions.hoverNode(NODE_ID_CHECK_IN_BUTTON)}
                    onMouseLeave={() => editor.actions.unhoverAllNodes()}
                />
            </NodeContainer>
            <Spacer $spacing={containerPaddingL} />
            <NodeContainer>
                <NodeButton
                    paddingLeft="0"
                    variation="navigation"
                    label={NODE_DISPLAY_NAME_FOOTER_CONTAINER}
                    qaId={NODE_ID_FOOTER_CONTAINER}
                    onClick={(e) => selectNode(e, NODE_ID_FOOTER_CONTAINER)}
                    onMouseEnter={() => editor.actions.hoverNode(NODE_ID_FOOTER_CONTAINER)}
                    onMouseLeave={() => editor.actions.unhoverAllNodes()}
                    bold
                />
                <NodeButton
                    variation="secondary"
                    label={NODE_DISPLAY_NAME_CONTACT_ORGANIZER_BUTTON}
                    qaId={NODE_ID_CONTACT_ORGANIZER_BUTTON}
                    onClick={(e) => selectNode(e, NODE_ID_CONTACT_ORGANIZER_BUTTON)}
                    onMouseEnter={() => editor.actions.hoverNode(NODE_ID_CONTACT_ORGANIZER_BUTTON)}
                    onMouseLeave={() => editor.actions.unhoverAllNodes()}
                />
                <Spacer $spacing={SPACING} />
                <NodeButton
                    variation="secondary"
                    label={NODE_DISPLAY_NAME_VISIT_EVENT_PAGE_BUTTON}
                    qaId={NODE_ID_VISIT_EVENT_PAGE_BUTTON}
                    onClick={(e) => selectNode(e, NODE_ID_VISIT_EVENT_PAGE_BUTTON)}
                    onMouseEnter={() => editor.actions.hoverNode(NODE_ID_VISIT_EVENT_PAGE_BUTTON)}
                    onMouseLeave={() => editor.actions.unhoverAllNodes()}
                />
                <Spacer $spacing={SPACING} />
                <NodeButton
                    variation="secondary"
                    label={NODE_DISPLAY_NAME_CUSTOM_BUTTON}
                    qaId={NODE_ID_CUSTOM_BUTTON}
                    onClick={(e) => selectNode(e, NODE_ID_CUSTOM_BUTTON)}
                    onMouseEnter={() => editor.actions.hoverNode(NODE_ID_CUSTOM_BUTTON)}
                    onMouseLeave={() => editor.actions.unhoverAllNodes()}
                    iconAfter={
                        <ShowHideButton
                            handleToggle={(e) => toggleNodeVisibility(e, NODE_ID_CUSTOM_BUTTON)}
                            visible={get(editor.nodes, [NODE_ID_CUSTOM_BUTTON, 'meta', 'visible'])}
                        />
                    }
                />
                <Spacer $spacing={SPACING} />
                <NodeButton
                    variation="secondary"
                    label={NODE_DISPLAY_NAME_CUSTOM_BUTTON_TWO}
                    qaId={NODE_ID_CUSTOM_BUTTON_TWO}
                    onClick={(e) => selectNode(e, NODE_ID_CUSTOM_BUTTON_TWO)}
                    onMouseEnter={() => editor.actions.hoverNode(NODE_ID_CUSTOM_BUTTON_TWO)}
                    onMouseLeave={() => editor.actions.unhoverAllNodes()}
                    iconAfter={
                        <ShowHideButton
                            handleToggle={(e) => toggleNodeVisibility(e, NODE_ID_CUSTOM_BUTTON_TWO)}
                            visible={get(editor.nodes, [NODE_ID_CUSTOM_BUTTON_TWO, 'meta', 'visible'])}
                        />
                    }
                />
            </NodeContainer>
        </SidebarPanel>
    );
}
